import { Route, Routes } from "react-router";
import { useModule } from "./api/hooks";
import type { ModuleId } from "./api/types";
import { RequireAuth } from "./auth/auth";
import { Shell } from "./layout/shell";
import { AdminLayout } from "./pages/admin/admin-layout";
import { DocumentPage } from "./pages/document/document-page";
import { DocumentsPage } from "./pages/documents/documents-page";
import { LoginPage } from "./pages/login";
import { NotFoundPage } from "./pages/placeholders";
import { SearchPage } from "./pages/search/search-page";
import { SettingsPage } from "./pages/settings/settings-page";
import { UploadPage } from "./pages/upload/upload-page";

/** Renders the page only while its module is on; a disabled module's address is a 404. */
function ModuleRoute({ id, element }: { id: ModuleId; element: React.ReactElement }) {
  return useModule(id) ? element : <NotFoundPage />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <Shell />
          </RequireAuth>
        }
      >
        <Route index element={<SearchPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="documents/:id" element={<DocumentPage />} />
        <Route path="upload" element={<ModuleRoute id="upload" element={<UploadPage />} />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route
          path="admin/*"
          element={
            <RequireAuth admin>
              <AdminLayout />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
